import {Refund, RefundStatusEnum} from 'domain/usecases';
import {useState} from 'react';
import {useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {cardStyleByStatus} from '../constants/cardByStatus';

const {status} = translations['pt-br'].privateFlow.consultRefund;

export function useRefundStatusDrawer() {
	const theme = useTheme();
	const [refundDataSate, setRefundDataState] = useState<Refund>();
	const [openDrawerState, setOpenDrawerState] = useState(false);
	const onOpenDrawer = () => {
		setOpenDrawerState(true);
	};
	const onCloseDrawer = () => {
		setOpenDrawerState(false);
	};
	const getRefundCardData = (data: Refund) => {
		if (data) {
			setRefundDataState(data);
			onOpenDrawer();
		}
	};
	const {footer: baseFooter, chipColor} = refundDataSate
		? cardStyleByStatus(theme, refundDataSate.situationCode)
		: {
				chipColor: theme.palette.customInfo.contrastText,
				footer: {chipVariant: 'default', chipText: status.registered} as const,
			};
	const footer =
		refundDataSate?.situationCode === RefundStatusEnum.IN_ANALYSIS_6
			? {...baseFooter, chipVariant: 'primary' as const}
			: baseFooter;
	return {
		openDrawerState,
		onOpenDrawer,
		onCloseDrawer,
		getRefundCardData,
		refundDataSate,
		footer,
		chipColor,
	};
}
